import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Home/Hero';
import { Carousel } from '../components/Home/Carousel';
import { Stats } from '../components/Home/Stats';
import { SuccessStories } from '../components/Home/SuccessStories';
import { Newsletter } from '../components/Home/Newsletter';
import { MembershipBenefits } from '../components/Home/MembershipBenefits';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
import { ServicePillars } from '../components/Home/ServicePillars';
import { SlidingGallery } from '../components/Home/SlidingGallery';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
import { initScrollAnimations, ANIMATION_CLASSES } from '../utils/animations';
interface HomeProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Home = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: HomeProps) => {
  const accessPointsRef = useRef<HTMLDivElement>(null);
  // Initialize ALL scroll animations (handles scroll-animate, scroll-animate-left, scroll-animate-right, scroll-animate-scale)
  useEffect(() => {
    const observer = initScrollAnimations();
    return () => observer?.disconnect();
  }, []);
  const scrollToAccessPoints = () => {
    if (accessPointsRef.current) {
      accessPointsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const openCorporateTrainingForm = () => {
    if ((window as any).openCorporateTrainingForm) {
      ;
      (window as any).openCorporateTrainingForm();
    }
  };
  const carouselImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    alt: 'The Networking Salon group photo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    alt: 'Five women at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    alt: 'Four people at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    alt: 'The Networking Salon event'
  }];
  return <main className="overflow-hidden" data-id="element-3213" data-mp="1fnh1a9scwkve">
      <Hero openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-3214" data-mp="23aykvi1gwcna" />

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-white" data-id="element-3215" data-mp="1tkdrqa4kc0br">
        <div className="container mx-auto px-4" data-id="element-3216" data-mp="1yjyms9gm3oj7">
          <div className="max-w-4xl mx-auto text-center mb-12 scroll-animate" data-id="element-3217" data-mp="1yinogp5xr8zh">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-3218" data-mp="2m9ayph3bqap7">
              Welcome to The Networking Salon
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-3219" data-mp="flu2n5cky8iv">
              A high-trust, multi-city professional ecosystem combining AI and
              digital skills training, authority-building masterclasses,
              networking salons, opportunity matching, recruitment support, and
              peer collaboration.
            </p>
          </div>

          <div className="scroll-animate-scale" style={{
          transitionDelay: '200ms'
        }} data-id="element-3220" data-mp="kd2c21dwttw1">
            <Carousel images={carouselImages} data-id="element-3221" data-mp="3ntivl2nnohws" />
          </div>
        </div>
      </section>

      {/* Animated section divider */}
      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3222" data-mp="5opgh5iqid22"></div>

      <div className="scroll-animate-left" data-id="element-3223" data-mp="oa168ew6vhg">
        <ServicePillars data-id="element-3224" data-mp="n8grdbzkwn2" />
      </div>

      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3225" data-mp="1h2jhqgcw7fxq"></div>

      <div className="scroll-animate-scale" data-id="element-3226" data-mp="1c3qctcbo8x96">
        <Stats data-id="element-3227" data-mp="1c2or8dx14sd7" />
      </div>

      <div className="scroll-animate-right" data-id="element-3228" data-mp="1c3ggz83y3vvk">
        <SlidingGallery data-id="element-3229" data-mp="27eena2wxmne8" />
      </div>

      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3230" data-mp="27fg3elst202t"></div>

      <div className="scroll-animate-left" data-id="element-3231" data-mp="2ce15kqrmattw">
        <SuccessStories data-id="element-3232" data-mp="2cesyftttydgh" />
      </div>

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-gray-50" data-id="element-3233" data-mp="2hbt4i4qojg7l">
        <div className="container mx-auto px-4" data-id="element-3234" data-mp="2maw2x6c5mo6l">
          <div className="text-center mb-12 scroll-animate" data-id="element-3235" data-mp="2mcqjk8ge7u4v">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-primary" data-id="element-3236" data-mp="2qdiwbboh4h5w">
              Ready to Get Started?
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-3237" data-mp="2va9aftgpx2oo">
              Join our community, partner with us, or explore our services to
              take your professional journey to the next level.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 scroll-animate-scale" style={{
          transitionDelay: '200ms'
        }} data-id="element-3238" data-mp="3a103t5xyk9tw">
            <Button onClick={scrollToAccessPoints} className="w-full md:w-auto shadow-lg" size="lg" data-id="element-3239" data-mp="12fhtd273555y">
              Join the Salon
            </Button>

            <Link to="/host-salon" className="w-full md:w-auto" data-id="element-3240" data-mp="tdib66kc3v1f">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3241" data-mp="tg4qwthdpguq">
                Host a Salon
              </Button>
            </Link>

            <Link to="/partner-with-us" className="w-full md:w-auto" data-id="element-3242" data-mp="1m1xqku7dofda">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3243" data-mp="1h3cmuksx3dk3">
                Partner with Us
              </Button>
            </Link>

            <Link to="/contact" className="w-full md:w-auto" data-id="element-3244" data-mp="1cbbgffifkh1z">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3245" data-mp="17eunm80adeik">
                Explore Services
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <div ref={accessPointsRef} className="scroll-animate" data-id="element-3246" data-mp="202gqtf5lqh4w">
        <MembershipBenefits data-id="element-3247" data-mp="3uakn4d6w0ucy" />
        <AccessPoints openPaymentForm={openPaymentForm} openCorporateTrainingForm={openCorporateTrainingForm} data-id="element-3248" data-mp="3uac92hz13j06" />
      </div>

      <div className="scroll-animate-scale" data-id="element-3249" data-mp="28w6rpeb6b09">
        <FinalCTA openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-3250" data-mp="3klkm6o8trow4" />
      </div>

      <div className="scroll-animate-right" data-id="element-3251" data-mp="3pi19xhc4418o">
        <Newsletter data-id="element-3252" data-mp="3amv1knpjnqc6" />
      </div>
    </main>;
};